import { createInjectionKey as o } from "./highrise529.mjs";
const n = o("n-config-provider");
export {
  n as configProviderInjectionKey
};
